export default "__VITE_ASSET__CKz2y1MC__"